const CLIENTS = [
    "Flipkart",
    "Amazon",
    "Uber Eats",
    "Google",
    "DoorDash",
    "MX Player",
    "Alibaba",
    "Coursera",
    "Internshala",
];

export default function Marquee() {
    const row = (ariaHidden) => (
        <div
            aria-hidden={ariaHidden || undefined}
            className="flex shrink-0 items-center gap-10 pr-10 sm:gap-16 sm:pr-16"
        >
            {CLIENTS.map((c) => (
                <div key={c} className="flex shrink-0 items-center gap-10 sm:gap-16">
                    <span className="whitespace-nowrap font-syne text-2xl font-bold uppercase tracking-tight text-slate-400 transition-colors duration-300 hover:text-ink sm:text-4xl">
                        {c}
                    </span>
                    <span className="h-2 w-2 rotate-45 bg-crimson/70" aria-hidden="true" />
                </div>
            ))}
        </div>
    );

    return (
        <section
            data-testid="client-marquee"
            className="overflow-hidden border-b border-line bg-paper py-8 sm:py-10"
        >
            <p className="mb-6 px-5 text-center font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 sm:px-8">
                Trusted by global industry leaders
            </p>
            <div className="group relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-paper to-transparent sm:w-32" />
                <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-paper to-transparent sm:w-32" />
                <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]">
                    {row(false)}
                    {row(true)}
                </div>
            </div>
        </section>
    );
}
